export class BatchCheckCallActionResponse {
  errors: string[] = [];

  constructor(opts?: Partial<BatchCheckCallActionResponse>) {
    if (opts?.errors != null) {
      this.errors = [...opts.errors];
    }
  }
}
